export default {
  labels: {
    order: 'Ordine',
    customer: 'Cliente',
  },
  tags: {
    new_customer: 'Nuovo cliente',
    loyal_customer: 'Cliente fedele',
  },
};
